export type Severity = "critical" | "high" | "warning" | "info" | "low";

const CONFIG: Record<Severity, { label: string; className: string }> = {
  critical: { label: "Crítico",  className: "badge-red" },
  high:     { label: "Alto",     className: "badge-red" },
  warning:  { label: "Atenção",  className: "badge-amber" },
  info:     { label: "Info",     className: "badge-blue" },
  low:      { label: "Baixo",    className: "badge-gray" },
};

export function SeverityBadge({ severity }: { severity: Severity | string }) {
  const cfg = CONFIG[severity as Severity] ?? CONFIG.info;
  return <span className={cfg.className}>{cfg.label}</span>;
}
